import { orderBy } from "lodash";
import { getRuntime } from "./Runtime.js";
export function matchStoryboard(storyboards, pathname) {
  // Put apps with longer homepage before shorter ones.
  // E.g., `/legacy/tool` will match first before `/legacy`.
  // This enables two apps with relationship of parent-child of homepage.
  const sortedStoryboards = orderBy(storyboards, storyboard => {
    var _storyboard$app$homep, _storyboard$app$homep2;
    return (_storyboard$app$homep = (_storyboard$app$homep2 = storyboard.app.homepage) === null || _storyboard$app$homep2 === void 0 ? void 0 : _storyboard$app$homep2.length) !== null && _storyboard$app$homep !== void 0 ? _storyboard$app$homep : 0;
  }, "desc");
  for (const storyboard of sortedStoryboards) {
    const homepage = storyboard.app.homepage;
    if (typeof homepage === "string" && homepage[0] === "/") {
      if (matchHomepage(homepage, pathname)) {
        return storyboard;
      }
    }
  }
}
export function matchHomepage(homepage, pathname) {
  return homepage === "/" ? pathname === homepage : `${pathname.replace(/\/+$/, "")}/`.startsWith(`${homepage.replace(/\/+$/, "")}/`);
}

// istanbul ignore next
/**
 * We say it's an outside app when at least one of the below conditions are true:
 *   - target app is not found.
 *   - target app is not the current app.
 *   - current app is non-standalone mode and target app is standalone mode.
 *
 * Note: when current app is standalone mode, other apps will not be found.
 */
export function isOutsideApp(storyboard) {
  var _getRuntime$getCurren;
  if (process.env.NODE_ENV === "test") {
    return false;
  }
  return !storyboard ||
  // Sometimes `storyboard.app.standaloneMode` is incorrect.
  ((_getRuntime$getCurren = getRuntime().getCurrentApp()) === null || _getRuntime$getCurren === void 0 ? void 0 : _getRuntime$getCurren.id) !== storyboard.app.id && !window.STANDALONE_MICRO_APPS && storyboard.app.standaloneMode;
}
//# sourceMappingURL=matchStoryboard.js.map